export enum Roles {
    SUPER = 'SUPER',
    ADMIN = 'ADMIN',
    SEARCH = 'SEARCH',
    VIEW = 'VIEW'
}
